<div class=" wrapper p-4">
    <div class="row">
        <div class="col-7 " style="position: relative; padding-bottom: 150px !important;">
            <div class="justify-content-start d-flex align-items-center">
                <div class="back-btn d-flex align-items-center" style="cursor: pointer; " (click)="goBack()">
                    <fa-icon class="icon-go-back" [icon]='faChevronLeft'></fa-icon>
                    <p class="m-0">Volver</p>
                </div>
            </div>
            <div class="date-select-wrapper d-flex align-items-center">
                <fa-icon class="icon-hour mr-4 " [icon]='faCalendarClock'></fa-icon>
                <p class="date-title m-0"> Horarios {{(dateString| date: 'dd MMMM y')}}</p>
            </div>
            <div class="schedules-wrapper">
                <!-- <div class="no-hours d-flex align-items-center" *ngIf="optionsHours.length==0">
                    <fa-icon class="icon-hour mr-4 " [icon]='faCalendarClock'></fa-icon>
                    <p class="m-0">Dura todo el día</p>
                </div> -->

                <!-- Hours -->
                <div *ngIf="optionsHours.length > 0">
                    <div class="row container-hours-event">
                        <div class="col-3 mt-4 d-flex justify-content-between chip-hour" style="cursor: pointer;"
                            *ngFor="let hour of optionsHours"
                            [class.hour-disabled]="numDaySelect == null || (dateString == (today | date:'yyyy-MM-dd') &&((hour.horaInicio  | date:'HH':'+0000') <= (today | date:'HH':'+0000')) || (fechasEvent.typeRepeat == 'week' && !hour.dayWeek.includes(numDaySelect)) || ((fechasEvent.typeRepeat == 'month' || (!fechasEvent.typeRepeat && !hour.fixedSchedule)) && !hour.dayMonth.includes(dateDaySelect)))"
                            (click)="changeHour(hour)">
                            <p class="hour-wrapper p-3 m-0 d-flex justify-content-center"
                                [ngClass]="{'hourSelected': hour?.id == hourSelected?.id}"> {{ hour.horaInicio |
                                date:'HH:mm':"+0000" }}h</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tickets -->
            <div class="date-wrapper" *ngIf="hourSelected">
                <div class="date-select-wrapper d-flex align-items-center">
                    <fa-icon class="icon-hour mr-4 " [icon]='faTicket'></fa-icon>
                    <p class="date-title m-0"> Entradas disponibles</p>
                </div>
                <div class="row container-hours-event">
                    <div class="col-4 mt-4 d-flex justify-content-between chip-hour" style="cursor: pointer;"
                        (click)="viewMap()">
                        <p class="hour-wrapper hourSelected p-3 m-0 d-flex justify-content-center"> Seleccionar butacas
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5">
            <app-products-resume></app-products-resume>
        </div>
    </div>

</div>